import React, { useEffect, useMemo, useState } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import { Input, FormCustom, Select, CheckBox } from '../../Components/Form/Form'
import Controllers from '../../Api/Controllers'

const ProductProductionForm = ({ data, onSubmit, disablebSubmit, loadSubmit, idProduct }) => {
    const [row, setRow] = useState({
        p_id_production: data.id_production,
        p_id_product: idProduct,
        p_qty: data.qty,
        p_key_product: data.key_product,
        p_qty_conversion: data.qty_conversion,
        p_new_qty: data.new_qty,
        p_new_id_product_unit: data.new_id_product_unit,
        p_has_conversion: data.has_conversion
    })

    const [ready, setReady] = useState(true)
    const [rowsUnits, setRowsUnits] = useState([])

    const cboUnit = useMemo(() => {
        if (!row.p_new_id_product_unit) {
            return
        }

        let finded = rowsUnits.find(t => parseInt(row.p_new_id_product_unit) === parseInt(t.id_product_unit))

        if (!finded) {
            return
        }
        return {
            label: finded.code_product_unit,
            value: finded.id_product_unit
        }
    }, [row.p_new_id_product_unit, rowsUnits])

    useEffect(() => {
        let promises = [
            Controllers.product.get_product_unit()
        ]

        Promise.all(promises).then(res => {
            setRowsUnits(res[0].data)
            setReady(true)
        })
    }, [])


    return <ReactPlaceholder ready={ready} rows={7}>
        <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
            <Input
                text="Código Producto"
                placeholder="Código Producto"
                classNameParent="col-12 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.key_product}
                onChange={e => setRow({ ...row, p_key_product: e.currentTarget.value })}
            />
            <Input
                text="Cantidad"
                placeholder="Cantidad"
                classNameParent="col-12 mb-2"
                icon="far fa-comment-alt"
                required
                invalid="El campo es obligatorio."
                defaultValue={data.qty}
                onChange={e => setRow({ ...row, p_qty: e.currentTarget.value })}
                type="number"
                min="1"
                step="1"
            />
            <CheckBox
                id={'chk-produccion-component'}
                classNameParent="col-12"
                onChange={e => {
                    console.log(e.currentTarget.checked)
                    if (e.currentTarget.checked) { 
                        setRow({ ...row, p_has_conversion: e.currentTarget.checked ? 1 : 0 })
                    } else {
                        setRow({ ...row, p_has_conversion: e.currentTarget.checked ? 1 : 0, p_qty_conversion: '', p_new_qty: '', p_new_id_product_unit: '' })
                    }
                }}
                defaultChecked={data.has_conversion === 1}
                text="¿Tiene Conversión?"
            />
            {row.p_has_conversion === 1 && <>
                <Input
                    text="Cantidad a producir"
                    placeholder="Cantidad a producir"
                    classNameParent="col-12 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    value={row.p_qty_conversion}
                    onChange={e => setRow({ ...row, p_qty_conversion: e.currentTarget.value })}
                    type="number"
                    min="1"
                    step="1"
                />
                {/* <Input
                    text="Nueva Cantidad Conversión"
                    placeholder="Nueva Cantidad Conversión"
                    classNameParent="col-12 mb-2"
                    icon="far fa-comment-alt"
                    required
                    invalid="El campo es obligatorio."
                    defaultValue={data.new_qty}
                    onChange={e => setRow({ ...row, p_new_qty: e.currentTarget.value })}
                    type="number"
                    min="1"
                    step="1"
                /> */}
                {/* <Select
                    classNameParent="col-12 mb-2"
                    icon="far fa-comment-alt"
                    text="Nueva Unidad de Medida"
                    options={rowsUnits.map(t => {
                        return {
                            label: t.code_product_unit,
                            value: t.id_product_unit
                        }
                    })}
                    value={cboUnit}
                    onChange={e => setRow({ ...row, p_new_id_product_unit: e.value })}
                /> */}
            </>}
        </FormCustom>
    </ReactPlaceholder>
}

ProductProductionForm.defaultProps = {
    data: {
        id_production: '',
        qty: '',
        key_product: ''
    },
    onSubmit: () => { },
    loadSubmit: false,
    idProduct: ''
}

export default ProductProductionForm;